<mat-card class="portal-page-heading mb-4">
  <mat-card-content>
    <div class="flex flex-row flex-wrap justify-start items-center gap-4">
      <mat-icon class="portal-heading-icon" fontIcon="bloodtype"></mat-icon>
      <h1 class="portal-page-title">Hemodialysis Technician</h1>

      <button *ngIf="editing || isNewLicense || license.id > 0" class="ml-auto" type="button"
          mat-raised-button color="accent"
          (click)="closeLicense()">Close</button>
    </div>
  </mat-card-content>
</mat-card>

<div class="flex flex-col pb-4 gap-4" *ngIf="licenseRequests.length > 0 && license.id === 0">
  <div *ngFor="let request of licenseRequests">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="hemo-claim-request-card-container">
        <mat-card>
          <mat-card-content>
            <div class="flex flex-col md:flex-row">
              <span class="text-xl font-bold">License Claim Request</span>
              <button class="ml-auto" type="button" mat-button color="warn" (click)="cancelLicenseRequest(request)">Cancel Request</button>
            </div>
            <div class="flex flex-col">
              <div class="flex flex-row items-center gap-4">
                <span class="text-lg font-semibold md:w-1/3">Owner Name</span>
                <span>{{request.owner}}</span>
              </div>
              <div class="flex flex-row items-center gap-4">
                <span class="text-lg font-semibold md:w-1/3">License Number</span>
                <span>{{request.licenseNumber}}</span>
              </div>
              <div *ngIf="!request.denied" class="flex flex-row items-center gap-4">
                <span class="text-lg font-semibold md:w-1/3">Request</span>
                <span class="portal-warning">Pending</span>
              </div>
              <div *ngIf="request.denied" class="flex flex-col">
                <span class="text-lg font-semibold portal-error">Claim Request Denied</span>
                <div class="flex flex-row gap-4 items-center">
                  <span class="text-lg font-semibold">Reason</span>
                  <span>{{request.deniedReason}}</span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<!-- No License Found -->
<div *ngIf="!editing" class="hemo-claim-card-container flex flex-col py-4 gap-4">
  <!--
    Claim An Existing License
  -->
  <mat-card *ngIf="showClaimLicense">
    <mat-card-content>
      <div class="flex flex-col gap-4">
        <div class="flex flex-col md:flex-row">
          <span class="text-xl font-bold">Claim an Existing Certification</span>
        </div>
        <form [formGroup]="requestForm">
          <div class="flex flex-col md:flex-row md:max-2xl:flex-wrap md:gap-4">
            <mat-form-field class="md:w-1/2">
              <mat-label>Technician Name</mat-label>
              <input matInput formControlName="owner">
              <mat-error *ngIf="requestForm.get('owner')?.invalid">
                Technician Name Required
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Last 4 of SSN</mat-label>
              <input matInput formControlName="requestData" maxlength="4">
              <mat-error *ngIf="requestForm.get('requestData')?.invalid">
                Last 4 of SSN Required
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Certification Number</mat-label>
              <input matInput formControlName="licenseNumber">
              <mat-error *ngIf="requestForm.get('licenseNumber')?.hasError('invalidLicense')">
                Cannot find certification
              </mat-error>
            </mat-form-field>
          </div>
        </form>
        <div class="flex flex-col md:flex-row">
          <button class="ml-auto" [disabled]="!requestForm.valid" type="button" mat-button color="primary" (click)="createLicenseRequest()">Claim</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!--
    Apply for a New License
  -->
  <mat-card class="hemo-apply-card" *ngIf="canCreateLicense() && license.id === 0">
    <mat-card-header>
      <mat-card-title>
        <span class="text-xl font-bold">{{licenses.length > 0 ? 'Apply for Full Certification' : 'No Certifications or Applications Found'}}</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="flex flex-row gap-8 justify-start items-center">
        <span class="text-lg">Start your application here.</span>
        <button mat-button color="primary" type="button" (click)="newLicense()">
          <span class="text-lg">Apply</span>
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- License List -->
<div class="flex flex-col gap-4" *ngIf="!isNewLicense && licenses.length > 0 && license.id === 0">
  <div *ngFor="let license of licenses">
    <div class="flex flex-col md:flex-row gap-4">
      <div class="hemo-license-card-container">
        <mat-card class="w-full">
          <mat-card-header class="mb-4">
            <mat-card-title>
              <div class="flex flex-row items-center pt-2">
                <span class="text-xl font-bold">{{license.full ? 'Full Certification' : 'Provisional Certification'}} {{license.isRenewal? ' Renewal' : ''}}</span>
                <div class="flex flex-col md:flex-row md:gap-4 items-center absolute right-8">

                  <button type="button" mat-button color="primary" *ngIf="canSelect(license)"
                    (click)="selectLicense(license)">Select</button>

                  <button *ngIf="isApproved(license)" type="button" mat-button color="primary"
                    (click)="openPDFDialog(license)">View Certificate</button>

                  <div class="flex flex-col">
                    <button *ngIf="canRenew(license) && (license.renewalCount === 0 || license.full)" type="button" mat-button color="accent" (click)="renewLicense(license)">Renew</button>
                    <button *ngIf="canRenewToFull(license)" type="button" mat-button color="accent" (click)="renewLicense(license, true)">Renew as Full</button>
                  </div>

                  <button *ngIf="canCancel(license)" type="button" mat-button color="warn"
                    (click)="cancelLicense(license)">Cancel</button>
                </div>
              </div>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="flex flex-col">
              <div class="flex flex-row items-center gap-4">
                <span class="text-base font-semibold w-1/2">Certification number:</span>
                <div class="flex flex-row items-center gap-2">
                  <span class="text-base" id="licenseId">{{license.licenseId}}</span>
                  <button mat-icon-button (click)="sharedService.copyToClipboard(license.licenseId!)" color="primary" matTooltip="Copy to Clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
              </div>
              <div class="flex flex-row items-center gap-4">
                <span class="text-base font-semibold w-1/2">Registrant:</span>
                <div>
                  <span class="text-lg">
                    {{
                      (license.applicantFirstName || license.applicantLastName)
                        ? ((license.applicantFirstName || '') + ' ' + (license.applicantLastName || '')).trim()
                        : 'TBD'
                    }}
                  </span>
                </div>
              </div>
              <div class="flex flex-row items-center gap-4">
                <span class="text-base font-semibold w-1/2">Status:</span>
                <div>
                  <span class="text-lg" [ngClass]="{
                    'portal-success': license.statuses?.[license.statuses.length - 1]?.label === sharedService.approved,
                    'text-yellow-900': license.statuses?.[license.statuses.length - 1]?.label === sharedService.renewal,
                    'text-red-900': license.statuses?.[license.statuses.length - 1]?.label === 'Expired'
                  }">
                  <div class="flex flex-col">
                    <span *ngFor="let status of license.statuses">
                      {{status.label}}
                    </span>
                  </div>
                  </span>
                </div>
              </div>
              <div class="flex flex-row items-center gap-4">
                <span class="text-base font-semibold w-1/2">Initial certification date:</span>
                <div>
                  <span class="text-lg">
                    {{ license.initialCertificationDate ? (license.initialCertificationDate | date:'MM/dd/yyyy') : 'TBD' }}
                  </span>
                </div>
              </div>
              <div class="flex flex-row items-center gap-4">
                <span class="text-base font-semibold w-1/2">Current certification date:</span>
                <div>
                  <span class="text-lg">
                    {{ license.approvedDate ? (license.approvedDate | date:'MM/dd/yyyy') : 'TBD' }}
                  </span>
                </div>
              </div>
              <div class="flex flex-row items-center gap-4">
                <span class="text-base font-semibold w-1/2">Expiration date:</span>
                <div>
                  <span class="text-lg">
                    {{ license.expirationDate ? (license.expirationDate | date:'MM/dd/yyyy') : 'TBD' }}
                  </span>
                </div>
              </div>
              <div *ngIf="!environment.production" class="flex flex-row gap-2 pt-2">
                <mat-form-field class="w-1/3">
                  <mat-label>Expiration Date</mat-label>
                  <input matInput [(ngModel)]="expirationDates[license.id]" [matDatepicker]="pickerExp" />
                  <mat-datepicker-toggle matSuffix [for]="pickerExp"></mat-datepicker-toggle>
                  <mat-datepicker #pickerExp></mat-datepicker>
                </mat-form-field>
                <button *ngIf="expirationDates[license.id] !== null" mat-button color="primary" (click)="setExpirationDate(license)">Set Expiration</button>
                <button class="ml-auto" type="button" mat-button color="accent"
                  (click)="setAsStarted(license.id)">Set as Started</button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<!-- License Stepper -->
<div *ngIf="editing || isNewLicense">
  <mat-stepper [orientation]="sharedService.isMobile ? 'vertical' : 'horizontal'" #HemoTechStepper linear (selectionChange)="changeStep($event)">
    <!-- Step 1: Application Type -->
    <mat-step>
      <ng-template matStepLabel>Begin Application</ng-template>
      <div class="flex flex-col gap-4">
        <span class="text-lg font-semibold">Select the type of certification you are applying for:</span>
        <form [formGroup]="licenseForm" class="w-full">
          <mat-radio-group formControlName="full" class="flex flex-wrap gap-4" [disabled]="locked">
            <mat-radio-button [value]="true" class="w-full md:w-1/2" [disabled]="locked">
              <span class="text-lg underline pr-4">
                Full Certification
              </span>
            </mat-radio-button>
            <mat-radio-button [value]="false" class="w-full md:w-1/2" [disabled]="locked">
              <span class="text-lg underline pr-4">
                Provisional Certification
              </span>
            </mat-radio-button>
          </mat-radio-group>
        </form>
      </div>
      <div class="mt-8 pt-4">
        <button mat-raised-button matStepperNext [disabled]="licenseForm.get('full')?.value === null">Next</button>
      </div>
    </mat-step>

    <!-- Step 2: Applicant Information -->
    <mat-step *ngIf="licenseForm.get('full')?.value !== null">
      <ng-template matStepLabel>Applicant Information</ng-template>
      <applicant-information *ngIf="license.id > 0"
                             [licenseMasterId]="license.licenseMasterId"
                             [licenseId]="license.id"
                             [licenseGuid]="license.licenseId!"
                             [isLocked]="locked"
                             [isRenewal]="license.isRenewal!"
                             (formValidityChange)="onApplicantInfoValidityChange($event)">
      </applicant-information>
      <div class="flex flex-row gap-4 pt-4">
        <button mat-raised-button matStepperPrevious>Back</button>
        <button mat-raised-button matStepperNext>Next</button>
      </div>
    </mat-step>

    <!-- Step 3: Employer Information -->
    <mat-step *ngIf="licenseForm.get('full')?.value !== null && license.id > 0">
      <ng-template matStepLabel>Employer Information</ng-template>
      <app-employer [licenseMasterId]="license.licenseMasterId"
                    [isLocked]="locked"
                    [isRenewal]="license.isRenewal!"
                    (formValidityChange)="onEmployerInfoValidityChange($event)">
      </app-employer>
      <div class="flex flex-row gap-4 pt-4">
        <button mat-raised-button matStepperPrevious>Back</button>
        <button mat-raised-button matStepperNext>Next</button>
      </div>
    </mat-step>

    <!-- Step 4: Questions -->
    <mat-step *ngIf="licenseForm.get('full')?.value !== null && license.id > 0">
      <ng-template matStepLabel>Questions</ng-template>
      <app-questions *ngIf="license.id > 0"
                     [licenseMasterId]="license.licenseMasterId"
                     [isLocked]="locked"
                     [isRenewal]="license.isRenewal!"
                     (formValidityChange)="onQuestionsValidityChange($event)">
      </app-questions>
      <div class="flex flex-row gap-4 pt-4">
        <button mat-raised-button matStepperPrevious>Back</button>
        <button mat-raised-button matStepperNext>Next</button>
      </div>
    </mat-step>

    <!-- Step 5: Certification -->
    <mat-step *ngIf="licenseForm.get('full')?.value !== null && license.id > 0">
      <ng-template matStepLabel>Education/Certification</ng-template>
      <app-certification *ngIf="license.id > 0"
                         [license]="license"
                         [isLocked]="locked"
                         [daysLate]="numberOfDaysLate"
                         (formValidityChange)="onCertificationValidityChange($event)">
      </app-certification>
      <div class="flex flex-row gap-4 pt-4">
        <button mat-raised-button matStepperPrevious>Back</button>
        <button mat-raised-button matStepperNext>Next</button>
      </div>
    </mat-step>

    <!-- Step 7: Submit Application -->
    <mat-step *ngIf="licenseForm.get('full')?.value !== null && license.id > 0">
      <ng-template matStepLabel>
        <span matTooltip="Submit Application" matTooltipPosition="below" [matTooltipShowDelay]="500">
          Submit Application
        </span>
      </ng-template>

      <div class="flex flex-col md:flex-row gap-4">
        <!-- Left Section -->
        <div class="flex flex-col gap-4 md:w-1/2" *ngIf="!locked">
          <span class="text-lg">
            Falsifying an application, supplying misleading information, or
            withholding information is ground for denial or revocation of
            certification.
          </span>

          <span class="text-lg">
            Falsifying an application, supplying misleading information,
            or withholding information is grounds for denial or revocation of certification.
            I declare, under penalties of perjury, that I have examined this application
            and all attachments and that to the best of my knowledge and belief,
            this information is true, correct, and complete.
          </span>

          <span class="text-lg">
            The Health Care Regulation & Quality Improvement (HCRQI) program will
            conduct a criminal record check through the Law Enforcement Data System
            (LEDS). Signature on this form indicates my consent for that criminal
            record check.
          </span>

          <div class="flex flex-col pb-4">
            <div class="flex flex-row gap-2">
              <span class="text-lg">
                The fee for this application is:
              </span>
              <span class="font-semibold text-lg">
                {{calculateFee() | currency}}
              </span>
            </div>
            <span class="text-lg">
              Your application will not be processed until payment is received.
            </span>
          </div>

          <form [formGroup]="signatureForm">
            <div class="flex flex-col md:flex-row gap-2">
              <!-- Administrator Signature -->
              <div class="flex flex-col gap-2 md:w-1/2">
                <span class="font-semibold">Applicant Signature</span>
                <mat-form-field>
                  <mat-label>Signature</mat-label>
                  <input matInput formControlName="electronicSignature" />
                  <mat-error *ngIf="signatureForm.get('electronicSignature')?.invalid">
                    A name is required
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Date Field -->
              <div class="flex flex-col gap-2 md:w-1/2">
                <span class="font-semibold">Date</span>
                <mat-form-field>
                  <input placeholder="mm/dd/yyyy" formControlName="signedDate" matInput [matDatepicker]="signed" [max]="sharedService.today" />
                  <mat-datepicker-toggle matSuffix [for]="signed"></mat-datepicker-toggle>
                  <mat-datepicker #signed>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>
                        Apply
                      </button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                  <mat-error *ngIf="signatureForm.get('signedDate')?.invalid">
                    Signature date required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="flex flex-col md:flex-row gap-2 md:items-center">
              <button *ngIf="licenseForm.valid &&
              validationErrors.length === 0 &&
              signatureForm.valid" type="button" class="ml-auto" mat-flat-button color="primary" (click)="submitLicense()">Submit</button>
            </div>
          </form>
        </div>

        <!-- Right Section: Incomplete Application Warning -->
        <div class="flex flex-col gap-4 md:w-1/2" *ngIf="(!licenseForm.valid || validationErrors.length > 0)">
          <span class="text-xl portal-error">Your Application is Incomplete</span>
          <span class="text-lg portal-error">Missing information must be provided before you can submit your
            application</span>
          <span class="portal-error pl-8" *ngIf="!licenseForm.valid">Application Type is incomplete</span>
          <div *ngFor="let error of validationErrors">
            <span class="portal-error pl-8">{{error}}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-4 md:w-1/3" *ngIf="locked">
        <span class="text-xl font-semibold">Thank you for submitting your Hemo Tech application.</span>
        <div class="flex flex-row gap-4">
          <span class="font-semibold">Signed by:</span>
          <span>{{license.electronicSignature}}</span>
        </div>
        <div class="flex flex-row gap-4">
          <span class="font-semibold">Date:</span>
          <span>{{license.signedDate | date}}</span>
        </div>

        <a mat-raised-button color="primary" [routerLink]="['/payments']">
          <span class="text-lg">View and pay your application fee</span>
        </a>

        <span class="text-lg">Applications will be processed in the order they are received.
          If you have questions about your application, please email
          <a href="mailto:mailbox.hclc@odhsoha.oregon.gov">mailbox.hclc&#64;odhsoha.oregon.gov</a>. Thank you.
        </span>
      </div>
      <!-- Navigation Buttons -->
      <div class="flex flex-col md:flex-row md:gap-4 pt-4">
        <button class="text-xl" mat-raised-button matStepperPrevious>Back</button>
        <button class="text-xl" *ngIf="!approved" mat-raised-button (click)="HemoTechStepper.reset()">Reset</button>
      </div>
    </mat-step>
  </mat-stepper>
</div>
